import * as React from "react";
const SvgFiRrLungs = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lungs_svg__a)">
      <path
        fill="#062147"
        d="M12 13.716a6 6 0 0 1-3.103 2.372l-2.581.86a.999.999 0 1 1-.632-1.897l2.581-.86A3.99 3.99 0 0 0 11 10.396V1a1 1 0 1 1 2 0v9.396c0 1.725 1.1 3.25 2.735 3.795l2.581.86a1 1 0 0 1-.632 1.897l-2.581-.86A6 6 0 0 1 12 13.716M10 18a1 1 0 0 0-1 1 2.25 2.25 0 0 1-1.673 2.175l-2.695.72c-.209.07-.408.075-.637.105a2.01 2.01 0 0 1-1.412-.591A1.98 1.98 0 0 1 2 19.997c0-1.251.143-2.502.424-3.72L4.08 9.099a3.98 3.98 0 0 1 3.897-3.1 1 1 0 1 0 0-2A5.97 5.97 0 0 0 2.13 8.65L.475 15.828A18.6 18.6 0 0 0 0 19.997c0 1.07.415 2.074 1.17 2.827A4.03 4.03 0 0 0 3.996 24h.006c.427 0 .853-.07 1.204-.19l2.636-.702A4.256 4.256 0 0 0 11 19a1 1 0 0 0-1-1m13.525-2.171-1.656-7.178A5.97 5.97 0 0 0 16.022 4a1 1 0 1 0 0 2 3.98 3.98 0 0 1 3.897 3.1l1.656 7.178c.281 1.217.424 2.468.424 3.719a1.98 1.98 0 0 1-.583 1.412 2.02 2.02 0 0 1-1.412.591 2.2 2.2 0 0 1-.695-.123l-2.638-.702A2.254 2.254 0 0 1 14.999 19a1 1 0 1 0-2 0 4.26 4.26 0 0 0 3.157 4.108l2.578.685c.412.138.872.234 1.269.208a4.03 4.03 0 0 0 2.826-1.176 3.96 3.96 0 0 0 1.17-2.827c0-1.402-.159-2.805-.474-4.169"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lungs_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLungs;
